import PropTypes from "prop-types";
import React from "react";
import { Redirect } from "react-router-dom";

import LoginLayout from "./LoginLayout";
import LoginForm from "./LoginForm";
import { containerizeLoginCmp } from "./containerizeLoginCmp";
import { intlShape, injectIntl, FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";
import { AUTH_TYPE_AUTHSERVER } from "actions/loginActions";

const STORED_RETURNURL = "ssoReturnUrl";

class DefaultLoginPage extends React.Component {
  trySsoRedirect() {
    let { query: { returnUrl }, clearSystemMessage } = this.props;

    // TODO: Requires rethinking of handling system wide errors
    clearSystemMessage();

    // Check returnUrl from query string or sessionStorage
    if (!returnUrl) {
      returnUrl = sessionStorage.getItem(STORED_RETURNURL);

      if (!returnUrl) {
        return false;
      }

      // Remove returnUrl before redirect
      sessionStorage.removeItem(STORED_RETURNURL);
    }

    location.href = returnUrl;
    return true;
  }

  componentDidMount() {
    const {
      query: { returnUrl = null } = {},
      loginConfig: { options = [] } = {},
      tryDetectOAuth,
    } = this.props;

    if (returnUrl) {
      sessionStorage.setItem(STORED_RETURNURL, returnUrl);
    }

    const option = options.find(opt => opt.authority === AUTH_TYPE_AUTHSERVER) || {};
    tryDetectOAuth(option.authority);
  }

  render() {
    const { isAuthenticated, query } = this.props;
    const { redirectTo = "" } = query;

    if (isAuthenticated) {
      if (this.trySsoRedirect()) {
        return null;
      }
      return <Redirect to={redirectTo.length ? redirectTo : "/"} />;
    }

    return (
      <LoginLayout {...this.props}>
        <div className="cxa-c-form">
          <legend>
            <h3>
              <FormattedMessage {...messages.login.loginHeaderTitle} />
            </h3>
          </legend>
          <LoginForm {...this.props} />
        </div>
      </LoginLayout>
    );
  }
}

DefaultLoginPage.propTypes = {
  isAuthenticated: PropTypes.bool,
  query: PropTypes.object,
  history: PropTypes.object,
  intl: intlShape.isRequired,
  loginConfig: PropTypes.object,
  tryDetectOAuth: PropTypes.func,
  clearSystemMessage: PropTypes.func,
};

export default injectIntl(containerizeLoginCmp(DefaultLoginPage));



// WEBPACK FOOTER //
// ./components/login/DefaultLoginPage.jsx